import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
const defaultOptions = {} as const;

export type ActivateInactiveAccountMutationVariables = GraphQLTypes.Exact<{
  accountId: GraphQLTypes.Scalars['String']['input'];
}>;

export type ActivateInactiveAccountMutationResult = { __typename?: 'Mutation' } & {
  activateInactiveAccount?: GraphQLTypes.Maybe<
    { __typename?: 'ActivateInactiveAccountPayload' } & {
      errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
    }
  >;
};

export const ActivateInactiveAccountDocument = /*#__PURE__*/ gql`
  mutation activateInactiveAccount($accountId: String!) {
    activateInactiveAccount(accountId: $accountId) {
      errors {
        message
        path
      }
    }
  }
`;

/**
 * __useActivateInactiveAccountMutation__
 *
 * To run a mutation, you first call `useActivateInactiveAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateInactiveAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateInactiveAccountMutation, { data, loading, error }] = useActivateInactiveAccountMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useActivateInactiveAccountMutation(
  baseOptions?: Apollo.MutationHookOptions<ActivateInactiveAccountMutationResult, ActivateInactiveAccountMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<ActivateInactiveAccountMutationResult, ActivateInactiveAccountMutationVariables>(
    ActivateInactiveAccountDocument,
    options
  );
}
export type ActivateInactiveAccountMutationHookResult = ReturnType<typeof useActivateInactiveAccountMutation>;
